<nav class="level">
    <!-- Left side -->
    <div class="level-left">
        <div class="level-item">
            <p class="title">
                <span *ngIf="!ctrl.cargando" class="icon is-medium">
                    <i class="{{icono}}"></i>
                </span>
                <span *ngIf="ctrl.cargando" class="icon is-medium">
                    <i class="icon-worldwide fa-spin"></i>
                </span>
                <span class="icon is-medium">
                    <i class="fa" [ngClass]="ctrl.moduloTitulo == 'Nuevo' ?  'icon-file': 'icon-edit-1'"></i>
                </span> {{modulo_actual}}
            </p>
        </div>

    </div>

    <!-- Right side -->
    <div class="level-right">
        <a class="navbar-item tooltip" (click)="ctrl.regresar()">
            <span class="icon fa-2x">
                <i class="icon-back"> </i>
            </span>
            <span class="tooltiptext">Regresar</span>
        </a>

        <a class="navbar-item tooltip" [ngClass]="{'is-loading': ctrl.cargando}" (click)="!ctrl.cargando ? ctrl.cargarDatos() : ''"
            id='cargar_datos_actualizar' *ngIf="ctrl.id">
            <span class="icon fa-2x">
                <i class="icon-worldwide"></i>
            </span>
            <span class="tooltiptext">Actualizar</span>
        </a>

        <a class="navbar-item tooltip" routerLink="{{url_nuevo}}" *ngIf="(permisos.indexOf(controlador + '.store') > -1 || permisos.indexOf( 'Sis' + controlador + '.store') > -1) && ctrl.id">
            <span class="icon fa-2x">
                <i class="icon-file"></i>
            </span>
            <span class="tooltiptext">Nuevo</span>
        </a>

        <a class="navbar-item tooltip" (click)="ctrl.imprimir()" *ngIf="(permisos.indexOf(controlador + '.show') > -1 || permisos.indexOf( 'Sis' + controlador + '.show') > -1) && ctrl.id">
            <span class="icon fa-2x">
                <i class="icon-printer2"></i>
            </span>
            <span class="tooltiptext">Imprimir</span>
        </a>

        <button class="navbar-item  is-success tooltip" type="submit" [ngClass]="{'is-loading': ctrl.cargando}" [disabled]="ctrl.dato.invalid || ctrl.cargando"
            *ngIf="controlador != 'CajaOperacionController' && (permisos.indexOf(controlador + '.store') > -1 || permisos.indexOf( 'Sis'+ controlador + '.store') > -1 || permisos.indexOf(controlador + '.update') > -1 || permisos.indexOf( 'Sis' + controlador + '.update') > -1)">
            <span class="icon fa-2x has-text-success">
                <i class="icon-diskette"> </i>
            </span>
            <span class="tooltiptext">Guardar</span>
        </button>
        <button class="navbar-item  is-danger tooltip" type="button" [ngClass]="{'is-loading': ctrl.cargando}" [disabled]="ctrl.cargando"
            (click)="ctrl.eliminar(ctrl.id)" *ngIf="(permisos.indexOf(controlador + '.destroy') > -1 || permisos.indexOf( 'Sis' + controlador + '.destroy') > -1) && ctrl.id">
            <span class="icon fa-2x has-text-danger">
                <i class="icon-trash"></i>
            </span>
            <span class="tooltiptext">Eliminar</span>
        </button>
    </div>
</nav>


<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo">
    <div class="bloquear-azul">

    </div>
    <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
        <span>Cargando...</span>
    </span>
</div>
